import { computed } from 'vue'
import type { ComputedRef } from 'vue'

export const QUIZ_URL_STATE_KEY = 'strapi:global-settings-quiz-url'

// The URL every isDefaultUrl CTA points to: the external app origin (env appUrl)
// plus the quiz path from the "Settings Global" single type. The path is fetched
// into useState by useStrapiGlobalSettings (awaited in the layouts); until it
// arrives — or when the single type is empty — CTAs fall back to the bare appUrl.
export const useDefaultCtaUrl = (): ComputedRef<string> => {
  const { public: { appUrl } } = useRuntimeConfig()
  const refQuizUrl = useState<string | null>(QUIZ_URL_STATE_KEY, () => null)

  return computed<string>(() => {
    const quizUrl = refQuizUrl.value?.trim()
    if (!quizUrl) return appUrl

    const path = quizUrl.startsWith('/') ? quizUrl : `/${quizUrl}`
    return `${appUrl.replace(/\/$/, '')}${path}`
  })
}
